var _style, _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 395 233",
    style: {
      enableBackground: "new 0 0 395 233"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000080178813031122359830000009654843475825147027_);}\n\t.st1{display:none;fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-opacity:0.1;}\n\t.st2{fill:url(#SVGID_00000051355157920357628950000012961768203021095080_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#C6C6C6;}\n\t.st4{opacity:0.5;}\n\t.st5{fill:url(#SVGID_00000098902497961803357610000009597091742556875692_);}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:0.676;stroke-opacity:0.1;}\n\t.st7{fill:none;stroke:#D8D5D1;stroke-width:1.051;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:url(#SVGID_00000138558173737653212670000017361022167193448357_);}\n\t.st9{fill:url(#SVGID_00000179640418285908349300000001808031271871815082_);}\n\t.st10{fill:url(#SVGID_00000133511151947896709810000013336907456817195701_);}\n\t.st11{fill:url(#SVGID_00000131345490078460281490000004373620440153953716_);}\n\t.st12{fill:url(#SVGID_00000125603746885612213180000010378885953320269483_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M16.3,0h362c8.8,0,16,7.2,16,16v201c0,8.8-7.2,16-16,16h-362c-8.8,0-16-7.2-16-16V16C0.3,7.2,7.5,0,16.3,0z "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146484518541588738930000001716794741829922743_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146484518541588738930000001716794741829922743_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.5,60.8L195.5,60.8c30.2,0,54.8,24.5,54.8,54.8l0,0c0,30.2-24.5,54.8-54.8,54.8l0,0 c-30.2,0-54.8-24.5-54.8-54.8l0,0C140.8,85.3,165.3,60.8,195.5,60.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009580469716126857330000011801662170806782121_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.3744,
    y1: 132.6055,
    x2: 119.7517,
    y2: 93.1464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009580469716126857330000011801662170806782121_)"
    },
    d: "M220.9,169.8h-53.6 c-16.6,0-30.1-13.5-30.1-30.1V86.1c0-16.6,13.5-30.1,30.1-30.1h53.6c16.6,0,30.1,13.5,30.1,30.1v53.6 C250.9,156.3,237.5,169.8,220.9,169.8z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.5,89.4l-4.3,4.3c-4.7-4.5-11.2-7.3-18.2-7.3c-14.6,0-26.5,11.9-26.5,26.5c0,7,2.8,13.5,7.3,18.2 l-4.3,4.3l-3.9-0.7c-0.2,0-0.5,0-0.6,0.2l-6.4,6.4c-0.2,0.2-0.3,0.5-0.2,0.7c0.1,0.3,0.3,0.4,0.6,0.5l3.9,0.6l0.6,3.9 c0,0.3,0.2,0.5,0.5,0.6c0.3,0.1,0.5,0,0.7-0.2l6.4-6.4c0.2-0.2,0.2-0.4,0.2-0.6l-0.7-3.9l4.3-4.3c4.7,4.5,11.2,7.3,18.2,7.3 c7,0,13.5-2.8,18.2-7.3l4.3,4.3l-0.7,3.9c0,0.2,0,0.5,0.2,0.6l6.4,6.4c0.2,0.2,0.5,0.3,0.7,0.2c0.3-0.1,0.4-0.3,0.5-0.6l0.6-3.9 l3.9-0.6c0.3,0,0.5-0.2,0.6-0.5c0.1-0.3,0-0.5-0.2-0.7l-6.4-6.4c-0.2-0.2-0.4-0.2-0.6-0.2l-3.9,0.7l-4.3-4.3 c4.5-4.7,7.3-11.2,7.3-18.2c0-7-2.8-13.5-7.3-18.2l4.3-4.3l3.9,0.7c0.2,0,0.5,0,0.6-0.2l6.4-6.4c0.2-0.2,0.3-0.5,0.2-0.7 c-0.1-0.3-0.3-0.4-0.6-0.5l-3.9-0.6l-0.6-3.9c0-0.3-0.2-0.5-0.5-0.6c-0.3-0.1-0.5,0-0.7,0.2l-6.4,6.4c-0.2,0.2-0.2,0.4-0.2,0.6 L216.5,89.4z M167.7,143.3l-0.5-2.6l-1.9,1.9l0.4,2.7L167.7,143.3z M222.8,142.6l-1.9-1.9l-0.5,2.6l1.9,1.9L222.8,142.6z  M170.4,137.6l-2,2l0.5,2.6l2-2L170.4,137.6z M217.3,140.1l2,2l0.5-2.6l-2-2L217.3,140.1z M224.5,139.3l-2.6,0.5l1.9,1.9l2.7-0.4 L224.5,139.3z M161.7,141.2l2.7,0.4l1.9-1.9l-2.6-0.5L161.7,141.2z M164.8,138.1l2.6,0.5l2-2l-2.6-0.5L164.8,138.1z M218.7,136.6 l2,2l2.6-0.5l-2-2L218.7,136.6z M208.5,128.3c-3.8,3.5-8.9,5.7-14.5,5.7s-10.7-2.2-14.5-5.7l-2.7,2.7c4.5,4.2,10.5,6.8,17.2,6.8 c6.7,0,12.7-2.6,17.2-6.8L208.5,128.3z M204.7,124.5c-2.8,2.6-6.5,4.1-10.6,4.1s-7.8-1.6-10.6-4.1l-2.8,2.8 c3.5,3.3,8.3,5.3,13.5,5.3s9.9-2,13.5-5.3L204.7,124.5z M212.3,95.7l-2.7,2.7c3.5,3.8,5.7,8.9,5.7,14.5c0,5.6-2.2,10.7-5.7,14.5 l2.7,2.7c4.2-4.5,6.8-10.5,6.8-17.2C219.1,106.2,216.5,100.2,212.3,95.7z M211.3,94.7c-4.5-4.2-10.5-6.8-17.2-6.8 c-13.8,0-25.1,11.2-25.1,25.1c0,6.7,2.6,12.7,6.8,17.2l2.7-2.7c-3.5-3.8-5.7-8.9-5.7-14.5c0-11.7,9.5-21.2,21.2-21.2 c5.6,0,10.7,2.2,14.5,5.7L211.3,94.7z M203.7,102.2c-2.5-2.3-5.9-3.7-9.6-3.7c-7.9,0-14.3,6.4-14.3,14.3c0,3.7,1.4,7.1,3.7,9.6 l1.1-1.1c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1l-1.1,1.1c2.5,2.3,5.9,3.7,9.6,3.7s7.1-1.4,9.6-3.7l-2.6-2.6 c-1.9,1.6-4.3,2.6-7,2.6c-5.9,0-10.6-4.8-10.6-10.6c0-5.9,4.8-10.6,10.6-10.6c2.7,0,5.1,1,7,2.6L203.7,102.2z M207.5,98.4 c-3.5-3.3-8.3-5.3-13.5-5.3c-10.9,0-19.8,8.9-19.8,19.8c0,5.2,2,9.9,5.3,13.5l2.8-2.8c-2.6-2.8-4.1-6.5-4.1-10.6 c0-8.7,7.1-15.8,15.8-15.8c4.1,0,7.8,1.6,10.6,4.1L207.5,98.4z M208.5,99.4l-2.8,2.8c2.6,2.8,4.1,6.5,4.1,10.6 c0,4.1-1.6,7.8-4.1,10.6l2.8,2.8c3.3-3.5,5.3-8.3,5.3-13.5C213.8,107.7,211.8,102.9,208.5,99.4z M204.7,103.2l-2.6,2.6 c1.6,1.9,2.6,4.3,2.6,7c0,2.7-1,5.1-2.6,7l2.6,2.6c2.3-2.5,3.7-5.9,3.7-9.6C208.4,109.2,207,105.8,204.7,103.2z M200.1,105.9 c-1.6-1.4-3.7-2.2-6-2.2c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2c2.3,0,4.4-0.8,6-2.2l-2.5-2.5c-1,0.7-2.2,1.2-3.5,1.2 c-3.1,0-5.7-2.5-5.7-5.7c0-3.1,2.5-5.7,5.7-5.7s5.7,2.5,5.7,5.7c0,1.3-0.4,2.5-1.2,3.5l2.5,2.5c1.4-1.6,2.2-3.7,2.2-6 c0-2.3-0.8-4.4-2.2-6l-1.3,1.3c-0.3,0.3-0.7,0.3-1,0c-0.3-0.3-0.3-0.7,0-1L200.1,105.9z M197.5,115.3c0.5-0.7,0.8-1.5,0.8-2.5 c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c0.9,0,1.8-0.3,2.5-0.8l-3-3c-0.3-0.3-0.3-0.7,0-1 c0.3-0.3,0.7-0.3,1,0L197.5,115.3z M223.3,87.7l-2.6-0.5l-2,2l2.6,0.5L223.3,87.7z M217.3,85.6l0.5,2.6l2-2l-0.5-2.6L217.3,85.6z  M223.8,84.1l-1.9,1.9l2.6,0.5l1.9-1.9L223.8,84.1z M220.5,82.4l0.5,2.6l1.9-1.9l-0.4-2.7L220.5,82.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045611536068547046610000009406527137286569346_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.9915,
    y1: 225.0288,
    x2: 246.8834,
    y2: 209.3358,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045611536068547046610000009406527137286569346_)"
    },
    d: "M276.4-8.2L276.4-8.2 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C251.4,3,262.6-8.2,276.4-8.2z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.4-7.8L276.4-7.8c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0c-13.6,0-24.7-11-24.7-24.7 l0,0C251.8,3.2,262.8-7.8,276.4-7.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M266.2,6.5l2.1,2.1 M287.2,6.5l-2.1,2.1 M287.2,27.6l-2.1-2.1 M266.2,27.6l2.1-2.1 M266.2,21.2h1.6  M272.5,6.5v1.6 M287.2,12.8h-1.6 M280.9,27.6V26 M283,21.2h3.7 M280.9,6.5v4.2 M266.2,12.8h4.2 M272.5,27.6v-4.2 M276.1,12.4 l-4.1,4.1c-0.2,0.2-0.3,0.3-0.4,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.4,0.4l4.1,4.1c0.2,0.2,0.3,0.3,0.4,0.4c0.1,0,0.2,0,0.3,0 c0.1,0,0.2-0.1,0.4-0.4l4.1-4.1c0.2-0.2,0.3-0.3,0.4-0.4c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.4-0.4l-4.1-4.1 c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1,0-0.2,0-0.3,0C276.4,12.1,276.3,12.2,276.1,12.4L276.1,12.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044898705512349249770000003500154035823083708_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.6089,
    y1: 150.3466,
    x2: 314.5009,
    y2: 134.6535,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044898705512349249770000003500154035823083708_)"
    },
    d: "M344.1,66.5L344.1,66.5 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C319.1,77.7,330.2,66.5,344.1,66.5z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M344.1,66.8L344.1,66.8c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7h0c-13.6,0-24.7-11-24.7-24.7 l0,0C319.4,77.9,330.4,66.8,344.1,66.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M348.5,98l2.1,2.1l4.2-4.2 M354.8,89.6h-21 M354.8,91.7v-4c0-1.2,0-1.8-0.2-2.2c-0.2-0.4-0.5-0.7-0.9-0.9 c-0.5-0.2-1-0.2-2.2-0.2h-14.3c-1.2,0-1.8,0-2.2,0.2c-0.4,0.2-0.7,0.5-0.9,0.9c-0.2,0.5-0.2,1-0.2,2.2v8c0,1.2,0,1.8,0.2,2.2 c0.2,0.4,0.5,0.7,0.9,0.9c0.4,0.2,1,0.2,2.2,0.2h7.1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125602938447745028670000002498297302873211300_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.6718,
    y1: 89.4041,
    x2: -2.4362,
    y2: 73.7111,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125602938447745028670000002498297302873211300_)"
    },
    d: "M27.1,127.4L27.1,127.4 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C2.1,138.6,13.3,127.4,27.1,127.4z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.1,127.8L27.1,127.8c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7h0c-13.6,0-24.7-11-24.7-24.7 l0,0C2.5,138.8,13.5,127.8,27.1,127.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20,163.2h14.7 M17.4,148.5h20 M25.2,142.2l-2.1,6.3l4.2,11l4.2-11l-2.1-6.3 M28,159.3l9.4-10.3 c0.2-0.2,0.3-0.3,0.3-0.4c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.3-0.4l-4.5-5.4c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1 c-0.1,0-0.1,0-0.3,0h-9.7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.2l-4.5,5.4c-0.2,0.2-0.2,0.3-0.3,0.4 c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.3,0.4l9.4,10.3c0.2,0.2,0.3,0.4,0.5,0.4c0.1,0,0.2,0,0.3,0C27.6,159.7,27.7,159.6,28,159.3 L28,159.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124149121856560836290000014906760537464571273_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.5964,
    y1: 42.4305,
    x2: 111.4884,
    y2: 26.7375,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124149121856560836290000014906760537464571273_)"
    },
    d: "M141,174.4L141,174.4 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C116,185.6,127.2,174.4,141,174.4z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M141,174.8L141,174.8c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7h0c-13.6,0-24.7-11-24.7-24.7 l0,0C116.4,185.8,127.4,174.8,141,174.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M134.5,189.8l-1.6,2.2c-0.3,0.4-0.5,0.6-0.5,0.8c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.4,0.1,1,0.1H149 c0.5,0,0.8,0,1-0.1c0.1-0.1,0.2-0.2,0.2-0.4c0-0.2-0.2-0.4-0.5-0.8l-1.6-2.2 M134.5,189.8c0.2-0.2,0.3-0.4,0.4-0.5 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.3,0,0.6,0h10.9c0.3,0,0.5,0,0.6,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.5 M134.5,189.8 l-2,2.6c-0.2,0.3-0.4,0.5-0.5,0.7c-0.1,0.2-0.1,0.3-0.2,0.5c0,0.2,0,0.4,0,0.8v12.3c0,1.2,0,1.8,0.2,2.2c0.2,0.4,0.5,0.7,0.9,0.9 c0.4,0.2,1,0.2,2.2,0.2h12.2c1.2,0,1.8,0,2.2-0.2c0.4-0.2,0.7-0.5,0.9-0.9c0.2-0.4,0.2-1,0.2-2.2v-12.3c0-0.4,0-0.6,0-0.8 c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.3-0.5-0.7l-2-2.6 M145.5,197.5c0,2.3-1.9,4.2-4.2,4.2c0,0,0,0,0,0c-2.3,0-4.2-1.9-4.2-4.2 "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023963387268529289910000015010495915631441340_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.3512,
    y1: 189.1407,
    x2: 56.2432,
    y2: 173.4477,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023963387268529289910000015010495915631441340_)"
    },
    d: "M85.8,27.7L85.8,27.7 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C60.8,38.9,72,27.7,85.8,27.7z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.8,28L85.8,28c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0c-13.6,0-24.7-11-24.7-24.7l0,0 C61.1,39.1,72.2,28,85.8,28z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M96.5,52v1c0,4.7-3.1,8.8-7.5,10.1c-5.6,1.6-11.4-1.5-13.1-7.1c-1.6-5.6,1.5-11.4,7.1-13.1 c2.4-0.7,5-0.5,7.3,0.5 M96.5,44.5L86,55l-3.2-3.2"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057114092846035780170000014613496075842458788_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.8446,
    y1: 52.2269,
    x2: 269.7366,
    y2: 36.5339,
    gradientTransform: "matrix(1 0 0 -1 0 234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057114092846035780170000014613496075842458788_)"
    },
    d: "M299.3,164.6L299.3,164.6 c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0C274.3,175.8,285.5,164.6,299.3,164.6z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.3,165L299.3,165c13.6,0,24.7,11,24.7,24.7l0,0c0,13.6-11,24.7-24.7,24.7l0,0c-13.6,0-24.7-11-24.7-24.7 l0,0C274.6,176,285.7,165,299.3,165z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.1,188.8l8.4,2.1l8.4-2.1 M291.1,188.8l8.4-9.5 M291.1,188.8l8.4-2.1 M307.9,188.8l-8.4-9.5  M307.9,188.8l-8.4-2.1 M299.5,179.3v7.4 M292.7,193l6.8,7.4l6.8-7.4l-6.8,1.6L292.7,193z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImage1);
export default __webpack_public_path__ + "static/media/BgImage1.c32cdf5c5c82ad65e0b401148fe1c6bf.svg";
export { ForwardRef as ReactComponent };